export default "__VITE_ASSET__ddc042ba__"